import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { FilterService, MessageService } from '@openng/optimus-ui/api';
import { provideOptimus } from '@openng/optimus-ui/config';
import translation from 'src/assets/i18n/messages.lt.json';
import { AppTheme, AppThemeOptions } from 'src/assets/theme/app-theme';

import { matchesAllTokens, SearchMatchMode } from './search-match/search-match';

/**
 * App-wide providers for the UI library: theme preset, Lithuanian component translations, the
 * root-level toast service, and the `tokenAnd` filter rule used by the select/multiselect/treeselect
 * primitives.
 *
 * The translation goes through the library config, whose app initializer applies it before the
 * root component is created.
 */
export function provideUi(): EnvironmentProviders {
	return makeEnvironmentProviders([
		MessageService,
		provideOptimus({
			theme: {
				preset: AppTheme,
				options: AppThemeOptions,
			},
			translation: translation.optimus,
		}),
		provideAppInitializer(() => {
			const filterService = inject(FilterService);
			filterService.register(SearchMatchMode.TokenAnd, (value: unknown, filter: unknown) =>
				matchesAllTokens(String(value ?? ''), (filter ?? '') as string)
			);
		}),
	]);
}
